import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { KeyboardArrowDown } from '@mui/icons-material'
import { FormControl, Select, type SelectProps } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

type SelectStyledProps = SelectProps & {
  disabled?: boolean
}

export const FormControlStyled = styled(FormControl)`
  .MuiSelect-select {
    padding: 0 18px 0 4px !important;
    border-radius: 5px;
    color: ${theme.colors.primary.main};
    font-weight: ${theme.typography.weight.lg};
  }
`

export const SelectStyled = styled(Select)<SelectStyledProps>`
  font-size: ${theme.typography.sizes.xs};
  background-color: transparent;
  border-radius: 5px;
  background-color: ${theme.colors.quartenary};
  cursor: pointer;

  .MuiSelect-select span {
    width: 100%;
    display: flex;
    overflow: hidden;

    ${({ disabled }) =>
      disabled &&
      css`
        -webkit-text-fill-color: ${theme.colors.neutral.medium};
      `}
  }

  .Mui-disabled {
    cursor: not-allowed;
    background-color: ${theme.colors.neutral[100]};
  }
`

export const ChevronDownIconStyled = styled(KeyboardArrowDown)`
  font-size: 18px;
  fill: ${theme.colors.primary.main};
`
